import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=b260a486&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b260a486",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b260a486')) {
      api.createRecord('b260a486', component.options)
    } else {
      api.reload('b260a486', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=b260a486&scoped=true&", function () {
      api.rerender('b260a486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R9Yl4BeyUCTb/JS/comp/Accordion.vue"
export default component.exports